import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Tears of Joy",
  date: new Date(2025, 0, 5),
  img: "/img/kittens.jpeg",
  tracks: [
    {
      title: "Introducing The Band",
      src: "/songs/2025-05-01/introducing_the_band.mp3",
      duration: 350.448,
    },
    {
      title: "Within Reach",
      src: "/songs/2025-05-01/within_reach.mp3",
      duration: 354.696,
    },
    {
      title: "Kittens In The Kitchen",
      src: "/songs/2025-05-01/kittens_in_the_kitchen.mp3",
      duration: 221.832,
    },
    {
      title: "Allure Of The Unknown",
      src: "/songs/2025-05-01/allure_of_the_unknown.mp3",
      duration: 652.2,
    },
    {
      title: "Turnpike Munchies",
      src: "/songs/2025-05-01/turnpike_munchies.mp3",
      duration: 994.32,
    },
    {
      title: "Walking Hand In Hand",
      src: "/songs/2025-05-01/walking_hand_in_hand.mp3",
      duration: 481.128,
    },
    {
      title: "Say Yeah",
      src: "/songs/2025-05-01/say_yeah.mp3",
      duration: 462.528,
    },
    {
      title: "Elegant Hooves",
      src: "/songs/2025-05-01/elegant_hooves.mp3",
      duration: 893.448,
    },
    {
      title: "Tiptoeing",
      src: "/songs/2025-05-01/tiptoeing.mp3",
      duration: 582.864,
    },
    {
      title: "Join The Fray",
      src: "/songs/2025-05-01/join_the_fray.mp3",
      duration: 343.44,
    },
    {
      title: "Icelandic Twins",
      src: "/songs/2025-05-01/icelandic_twins.mp3",
      duration: 497.304,
    },
    {
      title: "Somewhere Under The Bluebirds",
      src: "/songs/2025-05-01/somewhere_under_the_bluebirds.mp3",
      duration: 426.624,
    },
    {
      title: "Arctic You Late",
      src: "/songs/2025-05-01/arctic_you_late.mp3",
      duration: 1035.744,
    },
    {
      title: "Badger's Pretzels",
      src: "/songs/2025-05-01/badgers_pretzels.mp3",
      duration: 707.352,
    },
    {
      title: "Gated Communities",
      src: "/songs/2025-05-01/gated_communities.mp3",
      duration: 447,
    },
    {
      title: "No More Love Songs",
      src: "/songs/2025-05-01/no_more_love_songs.mp3",
      duration: 447.552,
    },
    {
      title: "The First Last Song (Of The Year)",
      src: "/songs/2025-05-01/the_first_last_song.mp3",
      duration: 484.728,
    },
  ],
};
export default album;
